import React, {
  useEffect,
  useCallback,
} from 'react';
import i18n from 'i18next';

import {
  getStatus,
} from 'redux-resource';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  Flex,
  Text,
} from 'web-styled';

import {
  uiActions,
} from 'web-actions';

import {
  history,
} from 'web-history';

import {
  Spinner,
  Button,
} from 'web-components';

import ClientDetailsList from '../ClientDetailsList';

type Props = {
  folderId: number,
  params: {
    status: string,
  },
  isArchived: boolean,
  clientInfo: any,
  resourceType: string,
};

const Templates = ({
  params,
  folderId,
  isArchived,
  clientInfo,
  resourceType,
}: Props) => {
  const isWorkout = resourceType === 'personalWorkouts';

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      coreActions.requestClientPersonalEntity({
        qs: {
          status: params.status || 'active',
        },
        clientId: clientInfo.id,
        resourceType,
      }),
    );
  }, [clientInfo.id, resourceType, params.status]);

  const mapState = useCallback(state => ({
    assigningStatus: getStatus(
      state,
      [
        `${resourceType}.requests.assignClient.status`,
        `${resourceType}.requests.unAssignClient.status`,
      ],
      false,
    ),
    fetchingStatus: getStatus(
      state,
      [
        `${resourceType}.requests.fetchPersonal${isWorkout ? 'Workouts' : 'Programs'}.status`,
      ],
    ),
    items: coreSelectors.getClientTemplates(
      clientInfo.id,
      resourceType,
    )(state),
  }), [clientInfo.id, resourceType, params.status]);

  const {
    items,
    assigningStatus,
    fetchingStatus,
  } = useSelector(mapState, shallowEqual);

  const onRequestArchive = (id) => {
    dispatch(
      coreActions.requestArchiveTemplate({
        id,
        resourceType,
      }),
    );
  };

  const onRequestRestore = (id) => {
    dispatch(
      coreActions.requestRestoreTemplate({
        id,
        resourceType,
      }),
    );
  };

  const onRequestDeleteItem = (id) => {
    const onConfirmAction = coreActions.requestUnAssignClient({
      id,
      resourceType,
    });

    dispatch(
      uiActions.confirmModal({
        modal: {
          title: 'Delete item',
          bodyText: 'Are you sure you want to delete selected items?',
        },
        onConfirmAction,
      }),
    );
  };

  return (
    <Flex
      fillSpace
    >
      {fetchingStatus.pending && (
        <Spinner message="Loading..." />
      )}
      {fetchingStatus.succeeded && (
        <Flex
          column
          fillSpace
          spacing={10}
        >
          {(!assigningStatus.pending && items) && (
            <ClientDetailsList
              items={items}
              tabName={isWorkout ? 'workouts' : 'programs'}
              isArchived={isArchived}
              onRequestArchive={onRequestArchive}
              onRequestRestore={onRequestRestore}
              onRequestDeleteItem={onRequestDeleteItem}
              emptyState={isArchived ? (
                <Text whiteSpace="pre-line">
                  <br />
                  {i18n.t(`assigned.archived_${isWorkout ? 'workouts' : 'programs'}.empty`)}
                  <br />
                  <br />
                  {i18n.t(`assigned.archived_${isWorkout ? 'workouts' : 'programs'}.empty.manual`)}
                  <br />
                </Text>
              ) : (
                <>
                  <Text whiteSpace="pre-line">
                    <br />
                    {i18n.t(`assigned.${isWorkout ? 'workouts' : 'programs'}.empty`)}
                    <br />
                    <br />
                    {i18n.t(`assigned.${isWorkout ? 'workouts' : 'programs'}.empty.manual`)}
                    <br />
                  </Text>
                  <Button
                    ghost
                    appearance="primary"
                    onClick={() => {
                      history.push(`/${isWorkout ? 'workout' : 'program'}_templates_folder/${folderId}`);
                    }}
                  >
                    {i18n.t(`see.${isWorkout ? 'workout' : 'program'}.list`)}
                  </Button>
                </>
              )}
            />
          )}
          {assigningStatus.pending && (
            <Spinner message="Assigning template..." />
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default Templates;
